import Achievements from "../homesection/achivements/Achievements";
import Description from "../homesection/description/Description";
import UpcomingEvents from "../homesection/events/UpcomingEvents";
import HeroSection from "../homesection/hero/Hero";
import JoinUs from "../homesection/join/JoinUs";
import Sponsor from "../homesection/sponsors/Sponsor";
import Trophie from "../homesection/trophies/Trophie";

const HomePage = () => {
    return (
        <div>
            <HeroSection/>
            <Description/>
            <Achievements/>
            <UpcomingEvents/>
            <Trophie/>
            <JoinUs/>
            <Sponsor/>
        </div>
    )
}

export default HomePage;

